import './index.css';
import { AddCashModal, WithdrawModal, TransferPokerModal } from '../../../component';
import { useDispatch, useSelector } from 'react-redux';
import {
  getRealBalanceObj,
  isPokerEnabled,
  isAccountVerified,
  getBankAccountData,
  staticPagesLink
} from '../../../utilities/helper';
import I18n from '../../../utilities/locale';
import { useEffect, useState } from 'react';
import { showErrorToast } from '../../../actions/app-actions-types';
import EventEmitter from '../../../utilities/EventEmitter';
import { useLink } from 'react-router-stack';
import DefaultContainer from '../../default_container';
import WalletTransactionsCard from '../../../component/wallet_transactions_card';
import constants from '../../../constants';

const AccountLanding = () => {
  const navigate = useLink();
  const dispatch = useDispatch();
  const { statuses, balanceInfo, bankAccounts } = useSelector((state: any) => state.user);
  const { themeType = 'light' } = useSelector((state: any) => state.setting);

  const [addCashVisible, setAddCashVisible] = useState(false);
  const [withdrawVisible, setWithdrawVisible] = useState(false);
  const [transferPokerModal, setTransferPokerModal] = useState(false);
  const defaultBankAccountData = getBankAccountData(bankAccounts);
  const isVerified = isAccountVerified(statuses);
  const balance = getRealBalanceObj(balanceInfo);

  useEffect(() => {
    window.addEventListener('message', refreshBalance);
    window.addEventListener('popstate', onClickBrowserBack);
    EventEmitter.emit('BalanceUpdate');
    return () => {
      window.removeEventListener('popstate', onClickBrowserBack);
      window.removeEventListener('message', refreshBalance);
    };
  }, []);

  const refreshBalance = (event: any) => {
    try {
      if (event?.data?.command_type === 'refresh_balance') {
        EventEmitter.emit('BalanceUpdate');
      }
      // eslint-disable-next-line no-empty
    } catch (error) {}
  };

  const onClickBrowserBack = () => {
    setAddCashVisible(false);
    setWithdrawVisible(false);
    setTransferPokerModal(false);
  };

  const onPressAddCash = () => {
    setAddCashVisible(true);
  };
  const onPressTransferPokerToWinnings = () => {
    setTransferPokerModal(true);
  };

  const onPressBonus = () => {
    navigate.push('/referral', null);
  };

  const onPressCashBack = () => {
    const url = `${staticPagesLink}offers.html?theme=${themeType}`;
    navigate.push('/iframe_page', {
      url,
      title: 'Offer Page'
    });
  };

  const onPressWithdraw = () => {
    if (isVerified) setWithdrawVisible(true);
    else dispatch(showErrorToast(I18n.t('PleaseVerifyAccount')));
  };

  const onPressTransactionHistory = () => {
    // navigate.push('/transaction_history', null);
  };

  const onPressDismissCashModal = () => {
    setAddCashVisible(false);
  };
  const onPressDismissWithdraw = () => {
    setWithdrawVisible(false);
  };
  const onPressDismissPoker = () => {
    setTransferPokerModal(false);
  };

  const onPressVerifyAccount = () => {
    navigate.push('/verify_account', null);
  };
  return (
    <DefaultContainer isWelcomeMessage={false}>
      {/* <Header onClickBack={onClickBack} title="Wallet" /> */}
      <div className="wallet_wrapper">
        <div className="wallet_add_cash_container">
          <div className="wallet_balance">
            <img src={constants.Images.Wallet} />
            <p>{`₹${balance['totalBalance']}`}</p>
          </div>
          <button className="wallet_add_cash_btn" onClick={onPressAddCash}>
            Add Cash
          </button>
        </div>
        <div className="wallet_history_wrapper">
          <WalletTransactionsCard
            walletTitle={'iGamio Wallet'}
            walletBalance={balance['primaryBalance']}
            walletBtnTitle={''}
            onPress={() => {}}
            infoMessage={'iGamio Wallet'}
          />
          <WalletTransactionsCard
            walletTitle={'Winnings'}
            walletBalance={balance['gameBalance']}
            walletBtnTitle={'Withdraw'}
            onPress={onPressWithdraw}
            infoMessage={I18n.translate('WithDrawMoneyDescEnable')}
          />
          {isPokerEnabled && (
            <WalletTransactionsCard
              walletTitle={'Poker Wallet'}
              walletBalance={balance['pokerBalance']}
              walletBtnTitle={'Transfer'}
              onPress={onPressTransferPokerToWinnings}
              infoMessage={'Poker Wallet'}
            />
          )}
          <WalletTransactionsCard
            walletTitle={'Cashback'}
            walletBalance={balance['cashbackBalance']}
            walletBtnTitle={'Earn More'}
            infoMessage={'Cashback Wallet'}
            onPress={onPressCashBack}
          />
          <WalletTransactionsCard
            walletTitle={'Bonus'}
            walletBalance={balance['bonusBalance']}
            walletBtnTitle={'Earn More'}
            infoMessage={'Refer and Earn'}
            onPress={onPressBonus}
          />
        </div>

        <AddCashModal
          totalAmount={balance['totalBalance']}
          visible={addCashVisible}
          onPressDismiss={onPressDismissCashModal}
          isPokerWebView={false}
        />
        <WithdrawModal
          bankAccountId={defaultBankAccountData['bankAccountId']}
          visible={withdrawVisible}
          onPressDismiss={onPressDismissWithdraw}
          playWallet={balance['gameBalance']}
        />
        <TransferPokerModal
          visible={transferPokerModal}
          pokerWallet={balance['pokerBalance']}
          gameWallet={balance['gameBalance']}
          onPressDismiss={onPressDismissPoker}
          isPokerWebView={false}
        />
        <div className="view_transaction_history_btn_container">
          <button className="view_transaction_history_btn" onClick={onPressTransactionHistory}>
            View Transaction History
          </button>
        </div>
        {!isVerified && (
          <div className="withdraw_container">
            <p>Verify your account to withdraw</p>
            <button className="withdraw_btn" onClick={onPressVerifyAccount}>
              Verify Account
            </button>
          </div>
        )}
      </div>
    </DefaultContainer>
  );
};

export default AccountLanding;
